module.exports = __webpack_public_path__ + "static/cr-good-7eca75774c11d783c4ac9338694293fb.png";